import { render, staticRenderFns } from "./AssessmentBlock.vue?vue&type=template&id=e196801a&"
import script from "./AssessmentBlock.vue?vue&type=script&lang=js&"
export * from "./AssessmentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports